import { render, staticRenderFns } from "./TaxaOcupacaoCard.vue?vue&type=template&id=968df87a&scoped=true&"
import script from "./TaxaOcupacaoCard.vue?vue&type=script&lang=js&"
export * from "./TaxaOcupacaoCard.vue?vue&type=script&lang=js&"
import style0 from "./TaxaOcupacaoCard.vue?vue&type=style&index=0&id=968df87a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968df87a",
  null
  
)

export default component.exports